export const workspaceNameRule = /^[A-Za-z0-9\s_-]*$/;
